// extracted by mini-css-extract-plugin
module.exports = {"center":"Contact_center__2NltS","mobile":"Contact_mobile__2O3bn","contact":"Contact_contact__jml8-"};